// extracted by mini-css-extract-plugin
module.exports = {"root":"footer-root_root__qGHsI"};